import styles from "./Popup.module.css"
import { ReactElement, useEffect } from "react";
import { handleBackgroundScroll } from "../../utils/backgroundScroll";
import { usePopup } from "../../context/PopupContext";
/**
* Props for the Popup component.
*/ 
interface PopupProps{
    title?: string, // Popup title
    content?: string, // Popup content
    onClose?: ()=>void, // Close popup handler
    onSubmit?: ()=>void, // Submit handler
    submitBtnText?: string, // Submit button text
    backBtnText?: string, // Back button text
    display?: boolean, // Whether to display
    className?:string, // Optional additional class
    cardClassName?:string, // Optional additional card class
    textMode?: boolean, // Optional flag - for full text modal
    children?: ReactElement,
    onPopup?: boolean // Optional flag whether popup is open on anothe popup - for handling scroll
}
/**
* A popup component with title, content, and action buttons.
*
* @param props Popup props
* @param {string} props.title - Popup title
* @param {string} props.content - Popup content
* @param {() => void} props.onClose - Close popup handler
* @param {() => void} props.onSubmit - Submit handler
* @param {string} props.submitBtnText - Submit button text
* @param {string} props.backBtnText - Back button text
* @param {boolean} props.display - Whether to display
* @param {string} props.className - Optional additional class
* @param {string} props.cardClassName - Optional additional card class

* @returns TSX.Element
*/
const Popup = ({title="Popup title", content, onClose, onSubmit, backBtnText="", cardClassName,submitBtnText="", display = false, className, textMode = false, children, onPopup = false}:PopupProps) => {
    const {isOpen, open, close, popupTarget } = usePopup();
    
    // Stop scroll on open
    useEffect(()=>{
        if(display === false && onPopup === true) return
        handleBackgroundScroll(display)
    }, [display])

    if(textMode){
        return(
            <div className={`${(display || isOpen) ? styles.SpecialOrder : styles.SpecialOrderHidden} ${className || ''}`}>
                <div className={styles.SpecialOrderBg} onClick={popupTarget?.onClose ?? onClose}></div>
                
                <div className={`${styles.SpecialOrderPopup} ${cardClassName || ''}`}>
                    <div className={styles.PopupContent}>
                        <div className={styles.PopupTitle}>
                            <p>{popupTarget?.title ?? title}</p>
                        </div>
                        <div className={styles.PopupContentText}>

                            {(content || popupTarget?.content) && (    
                            <div className={styles.PopupText}>
                                <p>{popupTarget?.content ?? content}</p>
                            </div>
                            )}
                            {children && (
                                <div className={styles.PopupText}>
                                    {children}
                                </div>
                            )}
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
    return(
        <>
        <div className={`${(display || isOpen) ? styles.SpecialOrder : styles.SpecialOrderHidden} ${className || ''}`}>
            <div className={styles.SpecialOrderBg} onClick={popupTarget?.onClose ?? onClose}></div>
            
            <div className={`${styles.SpecialOrderPopup} ${cardClassName || ''}`}>
                <div className={styles.PopupContent}>
                    <div className={styles.PopupTitle}>
                        <p>{popupTarget?.title ?? title}</p>
                    </div>
                    {(content || popupTarget?.content) && (    
                    <div className={styles.PopupText}>
                        <p>{popupTarget?.content ?? content}</p>
                    </div>
                    )}
                </div>
                <div className={styles.PopupButtons}>
                    <button className={styles.BackButton} onClick={popupTarget?.onClose ?? onClose}>
                        <p>{popupTarget?.backBtnText ?? backBtnText}</p>
                    </button>
                    <button className={styles.ProceedButton} onClick={popupTarget?.onSubmit ?? onSubmit}>
                        <p>{popupTarget?.submitBtnText ?? submitBtnText}</p>
                    </button>
                </div>
            </div>
        </div>
        </>
    )
};

export default Popup;